import { InvoicePaymentType } from "../models/InvoicePaymentType";
import {
	DepartmentPaymentTypeWorkflow,
	DepartmentPaymentTypeWorkflowOptions,
	DepartmentPaymentTypeWorkflowRequest
} from "../models/DepartmentPaymentTypeWorkflow";
import { deleteRequest, getRequest, host, patchRequest, postRequest } from "./apiService";

const workFlowsAPI = '/api/paymenttypes/workflows';

export async function getPaymentTypes() {
	return getRequest<InvoicePaymentType[]>(`${host}/api/paymenttypes`);
}

export async function getDepartmentPaymentTypeWorkflows() {
	return getRequest<DepartmentPaymentTypeWorkflow[]>(`${host}${workFlowsAPI}`);
}

export async function getDepartmentPaymentTypeWorkflowOptions() {
	return getRequest<DepartmentPaymentTypeWorkflowOptions>(`${host}${workFlowsAPI}/options`);
}

export async function addDepartmentPaymentTypeWorkflow(workflow: DepartmentPaymentTypeWorkflowRequest) {
	return postRequest<DepartmentPaymentTypeWorkflow | undefined>(`${host}${workFlowsAPI}`, workflow);
}

export async function updateDepartmentPaymentTypeWorkflow(workflow: DepartmentPaymentTypeWorkflowRequest) {
	return patchRequest<DepartmentPaymentTypeWorkflow>(
		`${host}${workFlowsAPI}/${workflow.departmentId}/${workflow.paymentTypeId}`,
		workflow
	);
}

export async function deleteDepartmentPaymentTypeWorkflow(workflow: DepartmentPaymentTypeWorkflow) {
	return deleteRequest(`${host}${workFlowsAPI}/${workflow.departmentId}/${workflow.paymentTypeId}`);
}
